module.exports = __webpack_public_path__ + "static/img/3_1_2.18a6e56a.jpg";